import { useCallback } from "react";
import dayjs from "../../../../../configs/dayjs";

export const useFormatMsgTime = () => {
  const format = useCallback((value: string): string => {
    const date = dayjs(value);

    const now = dayjs();

    const time: string = date.format("h:mm A");

    if (now.diff(date, "h") < 24) {
      return time;
    }

    if (now.diff(date, "y") > 0) {
      return `${date.format("MMM D, YYYY")} at ${time}`;
    } else {
      return `${date.format("MMM D")} at ${time}`;
    }
  }, []);

  return { format };
};
